import { render, staticRenderFns } from "./menuShopCart.vue?vue&type=template&id=ef9db9dc&scoped=true&"
import script from "./menuShopCart.vue?vue&type=script&lang=ts&"
export * from "./menuShopCart.vue?vue&type=script&lang=ts&"
import style0 from "./menuShopCart.vue?vue&type=style&index=0&id=ef9db9dc&scoped=true&lang=css&"
import style1 from "./menuShopCart.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9db9dc",
  null
  
)

export default component.exports